import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext'; // Assuming AuthContext is in the same folder
import { usePermissions } from '../../hooks/usePermissions';

export const hasRoutePermission = ({ permissionKey, permissionKeys = [], canView }) => {
  const requiredPermissions = [permissionKey, ...permissionKeys].filter(Boolean);
  return requiredPermissions.length === 0 || requiredPermissions.some((key) => canView(key));
};

const ProtectedRoute = ({ children, permissionKey, permissionKeys = [] }) => {
  const { isAuthenticated } = useAuth();
  const { canView, isLoading: isPermissionsLoading } = usePermissions();

  // If not authenticated, redirect to home
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const requiresComponentPermission = Boolean(permissionKey || permissionKeys.length > 0);

  if (requiresComponentPermission && isPermissionsLoading) {
    return (
      <div className="text-center p-5" role="status" aria-live="polite">
        <div className="spinner-border text-primary" aria-hidden="true" />
        <p className="mt-2">Loading permissions...</p>
      </div>
    );
  }

  if (!hasRoutePermission({ permissionKey, permissionKeys, canView })) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
